import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import UsersEditor from "./UsersEditor";

const UsersEditorPage = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = userId === "new";

  const createEmptyUser = () => ({
    _id: crypto.randomUUID(),
    firstName: "",
    lastName: "",
    email: "",
    isActive: "false",
    isDeveloper: "false",
    isAdmin: "false",
    isSuperAdmin: "false",
    roles: [],

  });

  useEffect(() => {
    const fetchUser = async () => {
      if (isNew) {
        setUser(createEmptyUser());
        setLoading(false);
      } else {
        try {
          const res = await fetch(`https://auth.poc.mrc.ai/api/users/${userId}`);
          const data = await res.json();
          setUser(data);
        } catch (error) {
          console.error("Error fetching user:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchUser();
  }, [userId, isNew]);

  const handleSave = async (updatedUser) => {
  try {
    const method = isNew ? "POST" : "PUT";
    const url = isNew
      ? `https://auth.poc.mrc.ai/api/users`
      : `https://auth.poc.mrc.ai/api/users/${userId}`;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedUser),
    });

    if (!res.ok) throw new Error("Failed to save user");

    const saved = await res.json();
    setUser(saved);
  } catch (err) {
    console.error("Error saving user:", err);
  }
};

  const handleClose = () => navigate("/");

  if (loading) return <Spinner />;

  return <UsersEditor user={user} onClose={handleClose} isNew={isNew} />;
};

export default UsersEditorPage;
